<script setup>
import {computed, defineProps, ref} from "vue";
import {couponConf} from "@/utils/config";
import router from "@/router";

const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  },
  type: {
    type: Object,
    default: () => {
      return couponConf["hkl-scal"];
    }
  }
});

const showProdInx = ref(1)
const product = computed(() => {
  return props.couponLst[showProdInx.value]?.data || []
})
const computedMile = (miles) => {
  return Object.keys(props.account).length < 1 || props.account.balance_miles >= miles
}
</script>

<template>
  <div class="coupon-list">
    <div class="product-header">
      <div class="bottom-header">
        <el-image :src="props.type?.headerImg"/>
      </div>
    </div>
    <div class="product-toolbar">
      <div class="product-toolbar-item" v-for="(item,inx) in props.couponLst" :class="{'active': inx === showProdInx}"
           :key="inx" @click="showProdInx=inx">
        {{ item.name }}
      </div>
    </div>
    <div class="product-its">
      <div class="product-item" v-for="(pro,inx) in product" :key="inx">
        <div class="product-image">
          <el-image :src="pro.img"/>
          <div class="face_value">
            <!--            <el-text :type="type.login === 'xm_air' ? 'primary' : 'danger'">-->
            ￥{{ pro.face_value }}
            <!--            </el-text>-->
          </div>
        </div>
        <div class="product-items">
          <h3>{{ pro.title }}</h3>
          <div class="pay-btn">

            <div class="pay-score">
              <div class="actives-tips" v-if="parseFloat(pro.score_data?.[type.login]?.discount) !== parseFloat(pro.score_data?.[type.login]?.total)">限时活动</div>
              <el-text :type="type.login === 'xm_air' ? 'primary' : 'danger'">
                <span class="score-number">{{
                    pro.score_data?.[type.login]?.discount
                  }}</span>{{ pro.score_data?.[type.login]?.unit }}
              </el-text>
              <el-text type="info" v-if="parseFloat(pro.score_data?.[type.login]?.discount) !== parseFloat(pro.score_data?.[type.login]?.total)">{{ pro.score_data?.[type.login]?.total }}{{ pro.score_data?.[type.login]?.unit }}</el-text>
            </div>
            <el-button :type="type.login === 'xm_air' ? 'primary' : 'danger'" round
                       v-if="computedMile(parseFloat(pro.score_data?.[type.login]?.discount))"
                       @click="router.push({name: 'detail',params: {id: pro.id}})">立即兑换
            </el-button>
            <el-button v-else type="info" round disabled>可用里程不足</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="coupon-list recharge-content">
    <div class="recharge-header">
      <el-image src="https://images.jifen360.com/hkl/rec.png"/>
    </div>
    <div class="recharge-content">
      <div class="recharge-info" v-for="(cont,ins) in type.desc" :key="ins">
        <h4>{{ cont.title }}</h4>
        <ol class="recharge-info-value">
          <li v-for="(item,inx) in cont.content" :key="inx" v-html="item"></li>
        </ol>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">

.coupon-list {
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  margin: 20px 15px 15px;
  box-shadow: var(--el-box-shadow);
  position: relative;

  .product-toolbar {
    display: flex;
    margin-bottom: 15px;

    .product-toolbar-item {
      line-height: 30px;
      background: #D3D3D3;
      box-sizing: border-box;
      padding: 0 10px;
      font-size: .8rem;
      border-radius: 45px;

      & + .product-toolbar-item {
        margin-left: 10px;
      }

      &.active {
        background: #F6D148;
        font-weight: 600;
      }
    }
  }

  .product-item {
    background: url("https://images.jifen360.com/hkl/product.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    & + .product-item {
      margin-top: 15px;
    }

    .product-image {
      flex-basis: 30%;
      width: 30%;
      box-sizing: border-box;
      padding: 15px;
      text-align: center;
      position: relative;
      overflow: hidden;

      .el-image {
        width: 100%;
        margin: auto;
      }

      .face_value {
        position: absolute;
        //padding: 2px;
        font-size: .5rem;
        //font-weight: 600;
        //删除线
        text-decoration: line-through;
        background: #F23A3A;
        width: 40px;
        border-radius: 15px 15px 0 0;
        bottom: 19px;
        left: 15px;
        color: #ffffff;
        line-height: 15px;
        text-align: center;
        height: 15px;
      }
    }

    .product-items {
      flex-basis: 70%;
      width: 70%;
      box-sizing: border-box;
      padding: 15px;
      position: relative;
      line-height: 1.75;



      .pay-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;

        .pay-score {
          position: relative;

          .actives-tips {
            position: absolute;
            display: inline-block;
            padding: 3px 8px;
            background: #D32F2F;
            color: #fff;
            border-radius: 5px;
            animation: float 2s ease-in-out infinite;
            font-size: .6rem;
            top: -10px;
            //right: -30px;
            right: 15px;

            // 气泡箭头
            &::after {
              content: '';
              position: absolute;
              left: -8px;
              top: 50%;
              transform: translateY(-50%);
              border: 5px solid transparent;
              border-right-color: #D32F2F;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateX(0);
            }
            50% {
              transform: translateX(-5px);
            }
          }
        }

        .el-text {
          font-size: .75rem;
        }

        .el-text--info{
          padding-left: 5px;
          //删除线
          text-decoration: line-through;
        }

        .score-number {
          font-size: 1.33rem;
        }

        .el-button{
          padding: 8px;
        }
      }
    }
  }
}

.recharge-content {
  background: none;
  box-shadow: none;
  padding: 0;

  .recharge-header {
    width: 100%;

    .el-image {
      width: 100%;
    }
  }

  .recharge-content {
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    margin-top: -10px;
    border-radius: 0 0 12px 12px;

    .recharge-info {
      line-height: 1.7;
      font-size: .8rem;
      text-align: justify-all;

      .recharge-info-value {
        padding-left: 15px;
      }
    }
  }
}
</style>